
  module.exports = {
  baseURL: '//note-server.hunger-valley.com/'
  }
  


// WEBPACK FOOTER //
// ./src/helpers/config-baseURL.js